$(document).ready(function () {
  setTimeout(function () {
    active_sub = $(
      ".rc-widget .rc-template__radio .rc-radio.subscription-radio"
    ).hasClass("rc-radio--active");
    if (active_sub == true) {
      var new_price = $(
        ".rc-radio--active .rc-radio__label .rc-radio__price"
      ).html();
      $(".product-form .price_d").html(new_price);

      $(".product-form__input input").change(function () {
        setTimeout(function () {
          var new_price = $(
            ".rc-radio--active .rc-radio__label .rc-radio__price"
          ).html();
          $(".product-form .price_d").html(new_price);
        }, 700);
      });
    }
  }, 700);

  $("body").on("change", ".product-form__input input", function () {
    if (!$(".rc-widget").length) {
      setTimeout(function () {
        var new_price_var = $(".priceSingle .orpr").html();
        $(".product-form .price_d").html(new_price_var);
      }, 700);
    }
  });

  $("body").on(
    "click",
    ".rc-widget .rc-template__radio .rc-radio.subscription-radio",
    function () {
      setTimeout(function () {
        active_sub = $(
          ".rc-widget .rc-template__radio .subscription-radio"
        ).hasClass("rc-radio--active");
        if (active_sub == true) {
          var new_price = $(
            ".rc-radio--active .rc-radio__label .rc-radio__price"
          ).html();
          $(".product-form .price_d").html(new_price);

          $(".product-form__input input").change(function () {
            setTimeout(function () {
              var new_price_var = $(
                ".rc-radio--active .rc-radio__label .rc-radio__price"
              ).html();
              $(".product-form .price_d").html(new_price_var);
            }, 700);
          });
        }
      }, 700);
    }
  );
  $("body").on(
    "click",
    ".rc-widget .rc-template__radio .rc-radio.onetime-radio",
    function () {
      setTimeout(function () {
        active_one_sub = $(
          ".rc-widget .rc-template__radio .onetime-radio"
        ).hasClass("rc-radio--active");
        if (active_one_sub == true) {
          var price = $(".pr_price.orpr").html();
          $(".product-form .price_d").html(price);

          $(".product-form__input input").change(function () {
            setTimeout(function () {
              price = $(".pr_price.orpr").html();
              var set_atc = $(".product-form .price_d").html(price);
            }, 700);
          });
        }
      }, 700);
    }
  );
});

$(document).ready(function () {
  $("label.subscribe-field").click(function () {
    $("label.subscribe-field").removeClass("subscribe-active");
    $(this).addClass("subscribe-active");
  });
});
$(document).ready(function () {
  $(".product-form__input.Fragrance input").change(function () {
    var set_attr = $(this).attr("value");
    $(".product-form__input.Fragrance .form__label strong").html(
      ":" + "&nbsp" + set_attr
    );
  });
  $(".product-form__input.Fragrance input").each(function () {
    if ($(this).is(":checked")) {
      var active_value = $(this).attr("value");
      $(".product-form__input.Fragrance .form__label strong").html(
        ":" + "&nbsp" + active_value
      );
    }
  });
});
// subscription js start

function setLocalStoragefromHomePage() {
  let productGrid = $(".featured-collection-product li.grid__item");
  $(productGrid).each(function (index, product) {
    let productTile = $(product).find(".ajax-add-to-cart").data("producttitle");
    let productid = $(product).find(".ajax-add-to-cart").data("productid");
    let subscription_Options = $(product).find(
      "form .custom-select__selector option"
    );
    let optionArray = [];
    subscription_Options.map((mapindex, option) => {
      let selling_plan = $(option).data("plan-option");
      let plan_id = $(option).data("sellingplanid");
      optionArray.push({
        id: plan_id,
        plan: selling_plan,
      });
    });

    // Create an object for the current product
    let productData = {
      id: productid,
      title: productTile,
      subscription_options: optionArray,
    };
    // Retrieve existing cart from local storage or initialize an empty array
    let cart = JSON.parse(localStorage.getItem("cartProduct")) || [];
    // Check if the product already exists in the cart
    let existingProductIndex = cart.findIndex((item) => item.id === productid);
    if (existingProductIndex !== -1) {
      // Update existing product in the cart
      cart[existingProductIndex] = productData;
    } else {
      // Add the new product to the cart
      cart.push(productData);
    }
    // Save the updated cart back to local storage
    localStorage.setItem("cartProduct", JSON.stringify(cart));
  });
}

function setLocalStoragefromProductPage() {
  let productForm = $(".product-form, product-form");
  let productTile = $(".header-product-title").text().trim();
  let productid = $(productForm).find('input[name="id"]').data("productid");
  let subscription_Options = $(".rc-selling-plans-dropdown__select option");
  let optionArray = [];
  subscription_Options.map((mapindex, option) => {
    let selling_plan = $(option).text();
    let plan_id = $(option).val();
    optionArray.push({
      id: plan_id,
      plan: selling_plan,
    });
  });

  // Create an object for the current product
  let productData = {
    id: productid,
    title: productTile,
    subscription_options: optionArray,
  };
  // Retrieve existing cart from local storage or initialize an empty array
  let cart = JSON.parse(localStorage.getItem("cartProduct")) || [];
  // Check if the product already exists in the cart
  let existingProductIndex = cart.findIndex((item) => item.id === productid);
  if (existingProductIndex !== -1) {
    // Update existing product in the cart
    cart[existingProductIndex] = productData;
  } else {
    // Add the new product to the cart
    cart.push(productData);
  }
  // Save the updated cart back to local storage
  localStorage.setItem("cartProduct", JSON.stringify(cart));
}

$(document).ready(function () {
  setLocalStoragefromHomePage();
  // setLocalStoragefromProductPage()
  let intervalId = setInterval(function () {
    let sellingPlanSelect = $(".rc-selling-plans-dropdown__select option");
    if (sellingPlanSelect.length !== 0) {
      setLocalStoragefromProductPage();
      clearInterval(intervalId);
    }
  }, 1000);

  setTimeout(function () {
    clearInterval(intervalId);
  }, 50000);

  // Check Subscription function
  function Checksubscription() {
    var radioValue = $(
      ".recharge_subscription_widget .product-form__radio:checked"
    ).val();
    if (radioValue == "one-time") {
      $(".onetime_per_price").show();
      $(".subscription_per_price").hide();
    } else {
      $(".onetime_per_price").hide();
      $(".subscription_per_price").show();
    }
  }
  // price udate function
  function Updateprices() {
    setTimeout(function () {
      var SubPrice = $(".subscription-radio .rc-radio__price").html();
      var onetimePrice = $(".onetime-radio .rc-radio__label")
        .text()
        .replace("One-time purchase", "");
      $(".onetime_price").html(onetimePrice);
      $(".subscribtion_price").html(SubPrice);
      const selectedRadio = $(
        'input[name="swsize"]:checked, input[name="swlaundry-sheet-scent"]:checked'
      );
      const compareAtPrice = parseFloat(
        selectedRadio.next("label").attr("data-compareprice")
      );
      const otPrice = parseFloat(
        selectedRadio.next("label").attr("data-onetimeprice")
      );
      const subPrice = parseFloat(
        selectedRadio.next("label").attr("data-subprice")
      );
      const finalPrice = (compareAtPrice / 100).toFixed(2);
      const finone = onetimePrice.replace("$", "");
      const shopCurrency =
        $("#product__compareprices").attr("data-currency") ||
        $(".product__compareprice").attr("data-currency") ||
        "$";
      console.log(compareAtPrice);
      if (otPrice !== compareAtPrice && compareAtPrice) {
        $(".product__compareprice").show();
        $(".product__compareprice").text(shopCurrency + finalPrice);
      } else {
        $(".product__compareprice").hide();
      }

      if (compareAtPrice !== subPrice && compareAtPrice) {
        $("#product__compareprices").show();
        $("#product__compareprices").text(shopCurrency + finalPrice);
      } else {
        $("#product__compareprices").hide();
      }
    }, 500);
  }
  Updateprices();
  $(document).on("click", ".swatchInput", function () {
    Checksubscription();
    if (document.querySelector(".rc-template__radio")) {
      Updateprices();
    }
  });
  if ($(".product-form__radio:checked").val() == "one-time") {
    $(".onetime-radio .rc-radio__input").trigger("click");
    $(".subscribe_data").hide();
    $(".onetime_per_price").show();
    $(".subscription_per_price").hide();
  } else {
    $(".subscription-radio .rc-radio__input").trigger("click");
    $(".subscribe_data").show();
    $(".onetime_per_price").hide();
    $(".subscription_per_price").show();
  }
  $(document).on("click", ".product-form__radio", function () {
    if ($(this).val() == "one-time") {
      $(".onetime-radio .rc-radio__input").trigger("click");
      $(".subscribe_data").hide();
      $(".onetime_per_price").show();
      $(".subscription_per_price").hide();
    } else {
      $(".subscription-radio .rc-radio__input").trigger("click");
      $(".subscribe_data").show();
      $(".onetime_per_price").hide();
      $(".subscription_per_price").show();
    }
  });
  var interval = setInterval(function () {
    if (document.querySelector(".rc-template__radio")) {
      $(".recharge_subscription_widget").show();
      var discount = $(".subscription-radio .rc-radio__subscription").text();
      var discountMatch = discount.match(/(\d+)%/);
      var percentage = discountMatch[1];
      var onetimePrice = $(".onetime-radio .rc-radio__label")
        .text()
        .replace("One-time purchase", "");
      var SubPrice = $(".subscription-radio .rc-radio__price").html();
      $(".discount_value").html(percentage + "%");
      $(".subscribtion_price").html(SubPrice);
      $(".onetime_price").html(onetimePrice);
      const selectedRadio = $('input[name="swsize"]:checked');
      const compareAtPrice = parseFloat(
        selectedRadio.next("label").attr("data-compareprice")
      );
      const finalPrice = (compareAtPrice / 100).toFixed(2);
      const finone = onetimePrice.replace("$", "");
      const shopCurrency =
        $("#product__compareprices").attr("data-currency") ||
        $(".product__compareprice").attr("data-currency") ||
        "$";
      if (!isNaN(finalPrice)) {
        if (parseFloat(finalPrice) !== parseFloat(finone)) {
          console.log(finalPrice);
          $("#product__compareprices").text(shopCurrency + finalPrice);
          $(".product__compareprice").text(shopCurrency + finalPrice);
        }
      }
      clearInterval(interval);
    }
  }, 500);
  var showinterval = setInterval(function () {
    if ($(".rc-template__radio").length) {
      $(".rc-selling-plans-dropdown__select option").each(function (
        index0,
        element0
      ) {
        $(this).attr(
          "data-plan-option",
          $(".custom-select__selector option:eq(" + index0 + ")").attr(
            "data-plan-option"
          )
        );
      });
      clearInterval(showinterval);
    }
  }, 1000);
  $(document).on("change", ".custom-select__selector", function () {
    var plan = $(this).find("option:selected").data("plan-option");
    var selectedIndex = $(this).find("option:selected").index();
    var selectedIndexVal = $(
      ".rc-selling-plans-dropdown__select option:eq(" + selectedIndex + ")"
    ).val();
    $("input[name=selling_plan]").val(selectedIndexVal);
    $(".rc-selling-plans-dropdown__select")
      .val(selectedIndexVal)
      .trigger("change");
  });
});

// subscription js end
// Subscription add to cart on homepage
$(document).on(
  "click",
  ".product-info-modal .product-form__input .custom-radio",
  function () {
    var subPrice = $(this)
      .parents(".input_item")
      .find("input[type=radio]")
      .data("subprice");
    var onetimePrice = $(this)
      .parents(".input_item")
      .find("input[type=radio]")
      .data("onetimeprice");
    $(".onetime_price").html(onetimePrice);
    $(".subscribtion_price").html(subPrice);
    var radioValue = $(this)
      .closest("form")
      .find(".recharge_subscription_widget .product-form__radio:checked")
      .val();
    if (radioValue == "one-time") {
      $(this).closest("form").find(".price_d").html(onetimePrice);
    } else {
      $(this).closest("form").find(".price_d").html(subPrice);
    }
  }
);
$(document).on(
  "click",
  ".product-info-modal .product-form__radio",
  function () {
    var subPrice = $(this)
      .parents(".recharge_subscription_widget")
      .find(".subscribtion_price")
      .html();
    var onetimePrice = $(this)
      .parents(".recharge_subscription_widget")
      .find(".onetime_price")
      .html();
    if ($(this).val() == "one-time") {
      $(this).parents("form").find(".price_d").html(onetimePrice);
    } else {
      $(this).parents("form").find(".price_d").html(subPrice);
    }
  }
);
$(document).on("click", ".ajax-add-to-cart", function () {
  let productTile = $(this).data("producttitle");
  let productid = $(this).data("productid");
  let subscription_Options = $(this)
    .closest("form")
    .find(".custom-select__selector option");
  let optionArray = [];
  subscription_Options.map((index, option) => {
    let selling_plan = $(option).data("plan-option");
    let plan_id = $(option).data("sellingplanid");
    optionArray.push({
      id: plan_id,
      plan: selling_plan,
    });
  });
  var variantID = $(this).closest("form").find('[name="id"]').val();
  var selling_plan = $(this)
    .closest("form")
    .find(".custom-select__selector")
    .find("option:selected")
    .data("sellingplanid");
  $(this).addClass("loading");
  $(".loading-overlay__spinner").removeClass("hidden");
  var radioValue = $(this)
    .closest("form")
    .find(".recharge_subscription_widget .product-form__radio:checked")
    .val();
  // Create an object for the current product
  let currentProduct = {
    id: productid,
    title: productTile,
    subscription_options: optionArray,
  };
  // Retrieve existing cart from local storage or initialize an empty array
  let cart = JSON.parse(localStorage.getItem("cartProduct")) || [];
  // Check if the product already exists in the cart
  let existingProductIndex = cart.findIndex((item) => item.id === productid);
  if (existingProductIndex !== -1) {
    // Update existing product in the cart
    cart[existingProductIndex] = currentProduct;
  } else {
    // Add the new product to the cart
    cart.push(currentProduct);
  }
  // Save the updated cart back to local storage
  localStorage.setItem("cartProduct", JSON.stringify(cart));
  // Continue with the rest of your code
  let cardreload = true;
  if (radioValue == "subscribe") {
    addItemToCart(variantID, 1, selling_plan, $(this), cardreload);
  } else {
    addToCartJS(1, variantID, $(this), cardreload);
  }
});
function addToCartJS(qty, variantID, btn, cardreload) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      setTimeout(function () {
        btn.removeClass("loading");
        $(".loading-overlay__spinner").addClass("hidden");
        $(".close-modal").click();
        // cardreload && drawerReload();
        cardreload();
      }, 650);
    }
  };
  var data = JSON.stringify({ quantity: qty, id: variantID });
  xhr.send(data);
}
function addItemToCart(variant_id, qty, selling_plan, btn, cardreload) {
  data = {
    id: variant_id,
    quantity: qty,
    selling_plan: selling_plan,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      setTimeout(function () {
        btn.removeClass("loading");
        btn.removeAttr("disabled");
        $(".loading-overlay__spinner").addClass("hidden");
        $(".close-modal").click();
        // cardreload && drawerReload();
        cardreload();
      }, 650);
    },
  });
}
// cart drawer js
// $(document).ready(function () {
//  function checkAndRemoveClasses() {
//    if ($("#rebuy-cart").length !== 0) {
//      if ($("body").hasClass("smart-cart--enabled")) {
//        $("body").removeClass("smart-cart--enabled");
//      }
//      if ($("body").hasClass("rebuy-modal-visible")) {
//        $("body").removeClass("rebuy-modal-visible");
//      }
//      $("div#rebuy-cart").remove();
//    }
//  }
//  setInterval(checkAndRemoveClasses, 500);
//  $("#cart-icon-bubble").click(function () {
//    $("body").removeClass("rebuy-modal-visible");
//  });
//});
// upsell product carousel
function drawerReload() {
  $("cart-drawer.drawer").addClass("animate");
  $.ajax({
    url: window.location.href,
    method: "GET",
    dataType: "html",
    success: function (htmlContent) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(htmlContent, "text/html");
      let cartBubble = doc.querySelector("#cart-icon-bubble").innerHTML;
      if (cartBubble) {
        $("#cart-icon-bubble").html(cartBubble);
      }
      let cartDrawerElement = doc.querySelector(
        "#CartDrawer .cart-drawer-content-wrapper"
      );
      if (cartDrawerElement) {
        $("#CartDrawer .cart-drawer-content-wrapper").replaceWith(
          cartDrawerElement.outerHTML
        );
        $("body").addClass("overflow-hidden");
        $("cart-drawer.drawer").removeClass("is-empty");
        $("cart-drawer.drawer").addClass("active");
      }
      sellingDataAddInCard();
    },
    error: function (error) {
      console.error("Error fetching and modifying HTML:", error);
    },
  });
}
$(document).on("click", ".refrence_cart_btn", function () {
  $(this).find(".loading-overlay__spinner").removeClass("hidden");
  $(this).addClass("disabled");
  let cardreload = true;
  let variantID = $(this).data("variantid");
  addToCartJS(1, variantID, $(this), cardreload);
});
$(document).on("click", "[data-update-To-Subscription]", function () {
  $(this).find(".loading-overlay__spinner").removeClass("hidden");
  let productId = $(this).data("product-id");
  let variantId = $(this).data("variant-id");
  let qty = $(this).closest(".cart-item").find(".quantity__input").val();
  addSubscriptionDataINCard(productId);
  let subscriptionPlan = $(this)
    .closest(".cart-item__subscription")
    .find(".cardDrower_subscription_select option:selected")
    .data("sellingplanid");
  removeProduct(variantId, function () {
    let cardreload = true;
    addItemToCart(variantId, qty, subscriptionPlan, $(this), cardreload);
  });
});
function removeProduct(variantId, callback) {
  $.ajax({
    url: "/cart/change.js",
    method: "POST",
    data: {
      quantity: 0,
      id: variantId,
    },
    dataType: "json",
    success: function (response) {
      if (callback && typeof callback === "function") {
        callback();
      }
    },
    error: function (error) {
      console.error("Error removing product:", error.responseText);
    },
  });
}
function addSubscriptionDataINCard(
  productId,
  subscriptionDiv,
  selectedSellingplan
) {
  // Retrieve existing cart from local storage
  let cart = JSON.parse(localStorage.getItem("cartProduct")) || [];
  // Find the product in the cart based on the product ID
  let selectedProduct = cart.find((item) => item.id === productId);
  if (selectedProduct) {
    // Get the subscription options for the selected product
    let subscriptionOptions = selectedProduct.subscription_options;
    // Create the HTML for the select dropdown
    let selectHtml =
      '<div class="subscription_plan"><select name="deliver-every" class="cardDrower_subscription_select">';
    subscriptionOptions.forEach((option) => {
      if (option.plan == selectedSellingplan) {
        selectHtml += `<option data-plan-option="Delivery every ${option.plan}" data-sellingplanid="${option.id}" selected>${option.plan}</option>`;
      } else {
        selectHtml += `<option data-plan-option="Delivery every ${option.plan}" data-sellingplanid="${option.id}">${option.plan}</option>`;
      }
    });
    selectHtml += "</select></div>";
    $(subscriptionDiv).html(selectHtml);
    $();
  } else {
    console.error("Product not found in the cart");
  }
}
function sellingDataAddInCard() {
  $(".cart-drawer tr.cart-item").each(function () {
    let selectedSellingplan = $(this)
      .find(".product-option.selling_plan")
      .text()
      .trim();
    let productId = $(this)
      .find(".cart-item__subscription .upgrade-btn")
      .data("product-id");
    let subscriptionDiv = $(this).find(".subscription-container");
    addSubscriptionDataINCard(productId, subscriptionDiv, selectedSellingplan);
  });
}
setTimeout(function () {
  sellingDataAddInCard();
}, 1000);
$(document).on("change", ".cardDrower_subscription_select", function () {
  $(this).attr("disabled", true);
  let variantId = $(this)
    .closest("td.cart-item__subscription")
    .find(".upgrade-btn")
    .data("variant-id");
  let sellingPlanId = $("option:selected", this).data("sellingplanid");
  let qty = $(this).closest(".cart-item").find(".quantity__input").val();
  removeProduct(variantId, function () {
    let cardreload = true;
    addItemToCart(variantId, qty, sellingPlanId, $(this), cardreload);
  });
});

// const xhttp = new XMLHttpRequest();
// xhttp.onload = function() {
//       if(JSON.parse(this.responseText).country == "AU") {
//           $(".shippingtext-AU").show();
//           $(".shippingtext-US").hide();
//           $(".shippingtext-NZ").hide();
//       }else if (JSON.parse(this.responseText).country == "US"){
//           $(".shippingtext-AU").hide();
//           $(".shippingtext-US").show();
//           $(".shippingtext-NZ").hide();
//        }else if (JSON.parse(this.responseText).country == "NZ"){
//           $(".shippingtext-AU").hide();
//           $(".shippingtext-US").hide();
//           $(".shippingtext-NZ").show();
//        }else {
//           $(".shippingtext-AU").hide();
//           $(".shippingtext-US").hide();
//           $(".shippingtext-NZ").hide();
//        }
// }
// xhttp.open("GET", "https://ipapi.co/json/");
// xhttp.send();

const xhttp = new XMLHttpRequest();

xhttp.onload = function () {
  try {
    const country = JSON.parse(this.responseText).country;
    showShippingText(country);
  } catch (error) {
    console.error("Error parsing response:", error);
  }
};

xhttp.onerror = function () {
  console.error("Error fetching data from the API");
};

xhttp.open("GET", "https://ipapi.co/json/");
xhttp.send();

function showShippingText(country) {
  $(".shippingtext-AU, .shippingtext-US, .shippingtext-NZ").hide();

  if (country === "AU") {
    $(".shippingtext-AU").show();
  } else if (country === "US") {
    $(".shippingtext-US").show();
  } else if (country === "NZ") {
    $(".shippingtext-NZ").show();
  }
  // If the country doesn't match any of the specified values, nothing will be shown.
}

function updateLabelsInPDP() {
  setTimeout(function () {
    var total_colors = jQuery(
      ".product-form__input.swatch:first-child .swatchLbl"
    ).length;
    var total_variants = productVariants.length;
    var total_options = jQuery(".product-form__input.swatch .swatchLbl").length;
    var selected_variant_id = parseInt(
      jQuery('.pr_variants[name="id"]').val(),
      10
    );
    var selected_variant = productVariants.find(
      (variant) => variant.id === selected_variant_id
    );
    var selected_index = productVariants.findIndex(
      (variant) => variant.id === selected_variant_id
    );
    var variants_per_color = total_variants / total_colors;
    var color_group_index = Math.floor(selected_index / variants_per_color);
    var size_options = jQuery(
      ".product-form__input.swatch:nth-child(2) .swatchLbl"
    );

    size_options.each(function (index) {
      var variant_index = color_group_index * variants_per_color + index;
      var variant_obj = productVariants[variant_index];

      if (variant_obj && variant_obj.save) {
        jQuery(this).find(".save").fadeIn();
        jQuery(this).find(".save").text(variant_obj.save);
      } else {
        jQuery(this).find(".save").fadeOut();
      }
    });
  }, 50);
}

// Announcement bar
$(document).ready(function () {
  $(".announcement-inner svg").on("click", function () {
    $(".custom-announcement").addClass("announcemnet-hide");
  });
  updateLabelsInPDP();
  jQuery(document).on(
    "click",
    ".product-form__input.swatch:first-child .swatchLbl",
    function () {
      updateLabelsInPDP();
    }
  );
});
